module.exports = __webpack_public_path__ + "img/logo-cancer-white.5bb27906.svg";